<h1 mat-dialog-title>Confirm</h1>
<mat-dialog-content><br>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onDismiss()">Cancel</button>
  <button mat-raised-button color="primary" cdkFocusInitial (click)="onOk()">Ok</button>
</mat-dialog-actions>
